import React from 'react'
import styled from '@nobia/zeus-components/lib/styled'
import { FormattedMessage } from '@nobia/zeus-components/lib/i18n'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'
import { cdnImage } from '../../utils'

const image = require('../../assets/intro.png')

const Header = styled(Column)`
  padding: 5%;
`

const IntroImage = styled.img`
  margin: auto;
  width: 100%;
  max-width: 270px;
`

const IntroLabel = styled.label`
  display: block;
  width: 70%;
  margin: auto auto 160px;
`

const CustomColumn = styled(Column)`
  padding: 3% 2%;
`

const Intro = () => (
  <Container>
    <Row>
      <Header>
        <CustomColumn xs={12}>
          <FormattedMessage
            tagName="h2"
            id="app.headline"
            defaultMessage="Zeus"
          />
        </CustomColumn>
      </Header>
    </Row>
    <Row>
      <CustomColumn xs={12}>
        <IntroImage src={cdnImage(image)} />
      </CustomColumn>
    </Row>
    <Row>
      <CustomColumn xs={12}>
        <IntroLabel>
          Add the first product to your wishlist by entering the 4 digit product
          code
        </IntroLabel>
      </CustomColumn>
    </Row>
  </Container>
)

export default Intro
